export const styles = {
  popover: {
    minWidth: '220px',
  },
}
